
<div class="col-md-12" style="padding:5px; overflow: auto;">
    <section class="example-table-container">
       <!-- (matSortChange)="announceSortChange($event)" -->
       <table mat-table [dataSource]="dataSource" matSort>
         <!-- data Title Column -->
         <ng-container matColumnDef="index">
           <th mat-header-cell *matHeaderCellDef>#</th>
           <td mat-cell *matCellDef="let element; let i = index">
             {{ i + 1 }}
           </td>
         </ng-container>

         <!-- data Detail Column -->
         <ng-container matColumnDef="title">
             <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
             <td mat-cell  *matCellDef="let element">

                <a [href]="element.url" target="_blank">{{
                   element.title
                 }}</a> 
             </td>
           </ng-container>
   
            <ng-container matColumnDef="descr">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
              <td mat-cell *matCellDef="let element">
                <p > {{ element.descr }}</p>
              </td>
            </ng-container> 
  
         <!-- Header and Row Definitions -->
         <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
         <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
       </table>
     </section>
</div>

